import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.for-each";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from 'axios';
import { extractHeadersFromAxiosResponse } from '../helpers/headers-helper';
import { httpDebugger } from './http.debugger';
import { retryHelper } from '../helpers/retry-helper';
export function getWithRetryAsync(instance, _call, functionsConfig, options) {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var _this = this;

    var retryStrategyOptions;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
            _context2.next = 3;
            return runWithRetryAsync({
              retryAttempt: 0,
              url: _call.url,
              retryStrategy: retryStrategyOptions,
              functionsConfig: functionsConfig,
              call: function call(retryAttempt) {
                return __awaiter(_this, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  var _b, _c, axiosResponse, response;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          httpDebugger.debugStartHttpRequest();
                          _context.next = 3;
                          return instance.get(_call.url, {
                            headers: getHeadersJson((_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [], false),
                            responseType: options === null || options === void 0 ? void 0 : options.responseType,
                            cancelToken: (_c = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _c === void 0 ? void 0 : _c.token
                          });

                        case 3:
                          axiosResponse = _context.sent;
                          response = {
                            data: axiosResponse.data,
                            rawResponse: axiosResponse,
                            headers: extractHeadersFromAxiosResponse(axiosResponse),
                            status: axiosResponse.status,
                            retryStrategy: {
                              options: retryStrategyOptions,
                              retryAttempts: retryAttempt
                            }
                          };
                          httpDebugger.debugSuccessHttpRequest();
                          return _context.abrupt("return", response);

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
              }
            });

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function postWithRetryAsync(instance, _call2, functionsConfig, options) {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var _this2 = this;

    var retryStrategyOptions;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
            _context4.next = 3;
            return runWithRetryAsync({
              retryAttempt: 0,
              url: _call2.url,
              retryStrategy: retryStrategyOptions,
              functionsConfig: functionsConfig,
              call: function call(retryAttempt) {
                return __awaiter(_this2, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee3() {
                  var _b, _c, axiosResponse, response;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          httpDebugger.debugStartHttpRequest();
                          _context3.next = 3;
                          return instance.post(_call2.url, _call2.body, {
                            headers: getHeadersJson((_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [], false),
                            responseType: options === null || options === void 0 ? void 0 : options.responseType,
                            // required for uploading large files
                            // https://github.com/axios/axios/issues/1362
                            maxContentLength: 'Infinity',
                            maxBodyLength: 'Infinity',
                            cancelToken: (_c = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _c === void 0 ? void 0 : _c.token
                          });

                        case 3:
                          axiosResponse = _context3.sent;
                          response = {
                            data: axiosResponse.data,
                            rawResponse: axiosResponse,
                            headers: extractHeadersFromAxiosResponse(axiosResponse),
                            status: axiosResponse.status,
                            retryStrategy: {
                              options: retryStrategyOptions,
                              retryAttempts: retryAttempt
                            }
                          };
                          httpDebugger.debugSuccessHttpRequest();
                          return _context3.abrupt("return", response);

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
              }
            });

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}
export function putWithRetryAsync(instance, _call3, functionsConfig, options) {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var _this3 = this;

    var retryStrategyOptions;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
            _context6.next = 3;
            return runWithRetryAsync({
              retryAttempt: 0,
              url: _call3.url,
              retryStrategy: retryStrategyOptions,
              functionsConfig: functionsConfig,
              call: function call(retryAttempt) {
                return __awaiter(_this3, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee5() {
                  var _b, _c, axiosResponse, response;

                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          httpDebugger.debugStartHttpRequest();
                          _context5.next = 3;
                          return instance.put(_call3.url, _call3.body, {
                            headers: getHeadersJson((_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [], false),
                            responseType: options === null || options === void 0 ? void 0 : options.responseType,
                            // required for uploading large files
                            // https://github.com/axios/axios/issues/1362
                            maxContentLength: 'Infinity',
                            maxBodyLength: 'Infinity',
                            cancelToken: (_c = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _c === void 0 ? void 0 : _c.token
                          });

                        case 3:
                          axiosResponse = _context5.sent;
                          response = {
                            data: axiosResponse.data,
                            rawResponse: axiosResponse,
                            headers: extractHeadersFromAxiosResponse(axiosResponse),
                            status: axiosResponse.status,
                            retryStrategy: {
                              options: retryStrategyOptions,
                              retryAttempts: retryAttempt
                            }
                          };
                          httpDebugger.debugSuccessHttpRequest();
                          return _context5.abrupt("return", response);

                        case 7:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
              }
            });

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}
export function patchWithRetryAsync(instance, _call4, functionsConfig, options) {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8() {
    var _this4 = this;

    var retryStrategyOptions;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
            _context8.next = 3;
            return runWithRetryAsync({
              retryAttempt: 0,
              url: _call4.url,
              retryStrategy: retryStrategyOptions,
              functionsConfig: functionsConfig,
              call: function call(retryAttempt) {
                return __awaiter(_this4, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee7() {
                  var _b, _c, axiosResponse, response;

                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          httpDebugger.debugStartHttpRequest();
                          _context7.next = 3;
                          return instance.patch(_call4.url, _call4.body, {
                            headers: getHeadersJson((_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [], false),
                            responseType: options === null || options === void 0 ? void 0 : options.responseType,
                            // required for uploading large files
                            // https://github.com/axios/axios/issues/1362
                            maxContentLength: 'Infinity',
                            maxBodyLength: 'Infinity',
                            cancelToken: (_c = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _c === void 0 ? void 0 : _c.token
                          });

                        case 3:
                          axiosResponse = _context7.sent;
                          response = {
                            data: axiosResponse.data,
                            rawResponse: axiosResponse,
                            headers: extractHeadersFromAxiosResponse(axiosResponse),
                            status: axiosResponse.status,
                            retryStrategy: {
                              options: retryStrategyOptions,
                              retryAttempts: retryAttempt
                            }
                          };
                          httpDebugger.debugSuccessHttpRequest();
                          return _context7.abrupt("return", response);

                        case 7:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));
              }
            });

          case 3:
            return _context8.abrupt("return", _context8.sent);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
}
export function deleteWithRetryAsync(instance, _call5, functionsConfig, options) {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10() {
    var _this5 = this;

    var retryStrategyOptions;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
            _context10.next = 3;
            return runWithRetryAsync({
              retryAttempt: 0,
              url: _call5.url,
              retryStrategy: retryStrategyOptions,
              functionsConfig: functionsConfig,
              call: function call(retryAttempt) {
                return __awaiter(_this5, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee9() {
                  var _b, _c, axiosResponse, response;

                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          httpDebugger.debugStartHttpRequest();
                          _context9.next = 3;
                          return instance["delete"](_call5.url, {
                            headers: getHeadersJson((_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [], false),
                            responseType: options === null || options === void 0 ? void 0 : options.responseType,
                            // required for uploading large files
                            // https://github.com/axios/axios/issues/1362
                            maxContentLength: 'Infinity',
                            maxBodyLength: 'Infinity',
                            cancelToken: (_c = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _c === void 0 ? void 0 : _c.token
                          });

                        case 3:
                          axiosResponse = _context9.sent;
                          response = {
                            data: axiosResponse.data,
                            rawResponse: axiosResponse,
                            headers: extractHeadersFromAxiosResponse(axiosResponse),
                            status: axiosResponse.status,
                            retryStrategy: {
                              options: retryStrategyOptions,
                              retryAttempts: retryAttempt
                            }
                          };
                          httpDebugger.debugSuccessHttpRequest();
                          return _context9.abrupt("return", response);

                        case 7:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));
              }
            });

          case 3:
            return _context10.abrupt("return", _context10.sent);

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
}
export function createCancelToken() {
  var canceler;
  var token = new axios.CancelToken(function (c) {
    // An executor function receives a cancel function as a parameter
    canceler = c;
  });
  return {
    cancel: function cancel(cancelMessage) {
      return canceler("".concat(retryHelper.requestCancelledMessagePrefix, ": ").concat(cancelMessage !== null && cancelMessage !== void 0 ? cancelMessage : 'User cancel'));
    },
    token: token
  };
}

function runWithRetryAsync(data) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee11() {
    var retryResult;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return data.call(data.retryAttempt);

          case 3:
            return _context11.abrupt("return", _context11.sent);

          case 6:
            _context11.prev = 6;
            _context11.t0 = _context11["catch"](0);
            retryResult = retryHelper.getRetryErrorResult({
              error: _context11.t0,
              retryAttempt: data.retryAttempt,
              retryStrategy: data.retryStrategy
            });

            if (!retryResult.canRetry) {
              _context11.next = 17;
              break;
            }

            httpDebugger.debugRetryHttpRequest(); // wait time before retrying

            _context11.next = 13;
            return new Promise(function (resolve) {
              return setTimeout(resolve, retryResult.retryInMs);
            });

          case 13:
            // retry request
            console.warn("Retry attempt '".concat(data.retryAttempt + 1, "' from a maximum of '").concat(retryResult.maxRetries, "' retries. Request url: '").concat(data.url, "'"));
            _context11.next = 16;
            return runWithRetryAsync({
              call: data.call,
              retryStrategy: data.retryStrategy,
              retryAttempt: data.retryAttempt + 1,
              url: data.url,
              functionsConfig: data.functionsConfig
            });

          case 16:
            return _context11.abrupt("return", _context11.sent);

          case 17:
            if (data.functionsConfig.logErrorsToConsole) {
              console.error("Executing '".concat(data.url, "' failed. Request was retried '").concat(data.retryAttempt, "' times. "), _context11.t0);
            }

            throw _context11.t0;

          case 19:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 6]]);
  }));
}

function getHeadersJson(headers, addContentTypeHeader) {
  var headerJson = {};
  headers.forEach(function (header) {
    headerJson[header.header] = header.value;
  });

  if (addContentTypeHeader) {
    // add default content type header if not present
    var contentTypeHeader = headers.find(function (m) {
      return m.header.toLowerCase() === 'Content-Type'.toLowerCase();
    });

    if (!contentTypeHeader) {
      headerJson['Content-Type'] = 'application/json';
    }
  }

  return headerJson;
}